 
$(document).ready(function(){
  if(window.innerWidth <= 767){
    $('.tab-pane').hide().removeClass('active');
    $('a[data-name="style"]').closest('li').removeClass('active');
  }else{
     $('#style').show().addClass('active');
    $('a[data-name="style"]').closest('li').addClass('active');
  }
	$('body').on('click', '.close_icon' , function(e){
       var data = $(this).attr('data-name');
      console.log('data', data);
      $('#'+data).removeClass('active').hide();
      $('a[data-name="'+data+'"]').closest('li').removeClass('active');
    })
  $('body').on('change mousemove touchmove', '.image-rotate[type="range"]' , function(e){
      // $(this).siblings('.letter_img_wrapper_rel').find('img').css('transform', 'rotate(' + $(this).val() / 2 + 'deg)')
     $('.rotate.active').closest('.ui-selected-letter').find('img').css('transform', 'rotate(' + $(this).val() / 2 + 'deg)')
    });
var drop_item_number = 0;
	$('body').on('click hover', '.letter_img_wrapper_rel' , function(e){
      $('.cust-front-img  .letter_img_wrapper_rel').closest('.ui-selected-letter').removeClass('active')
      $(this).closest('.ui-selected-letter').addClass('active')
    })
  
    $('.style-tab-wrapper .custom-radio input[type="radio"][value="'+$('.variant-input input[type="radio"][name="Style"]:checked').val()+'"]').trigger('click')
    var src = $('.style-tab-wrapper .custom-radio input[type="radio"]:checked').closest('.style-tab-list').find('.image_v').attr('src')
      $('#feature-row__image').attr('data-srcimg',src);
      $('#feature-row__image').attr('srcset',src);
      $('#feature-row__image').attr('src',src);
  
  
	$('body').on('click', '.style-tab-wrapper .custom-radio input[type="radio"]' , function(e){
       if(window.innerWidth <= 767){
          $('.tab-pane').hide().removeClass('active');
          $('.nav-tabs li').removeClass('active')
      }
      $('.variant-input input[type="radio"][value="'+$(this).val()+'"]').trigger('click')
      var src = $(this).closest('.style-tab-list').find('.image_v').attr('src')
      $('#feature-row__image').attr('data-srcimg',src);
      $('#feature-row__image').attr('srcset',src);
      $('#feature-row__image').attr('src',src);
    })
	$('body').on('click', '.rotate' , function(e){
       var topr = 80;
              if(window.innerWidth <= 767){
                 topr = 58;
              }
		$('.image-rotate').slideToggle('medium').css({
						left:($(this).closest('.ui-selected-letter')[0].offsetLeft),
						top:($(this).closest('.ui-selected-letter')[0].offsetTop + topr),
					});;
		$(this).toggleClass('active');
		e.stopPropagation()
	});
	$(document).click(function(e){
		if ($(e.target).is(".image-rotate") == false) {
			$(".image-rotate").css("display","none");
			$('.rotate').removeClass('active');
		}
	});

  $('body').on('click','.button.altcolour',function(){
		$('.dropped').removeClass("active");
		$('.dropped').addClass("ui-selected-letter");
		$(this).closest('#letter-drop-popup').removeClass('popup-open');
	});
  $('.nav-tabs li a').click(function(){
      var data = $(this).attr('data-name');
      $(this).parent().siblings().removeClass('active');
      $(this).parent().addClass('active');
      
      $('.tab-content .tab-pane').hide();
      $(".tab-content .tab-pane#"+data).show();
      
      $('.tab-content .tab-pane').removeClass('active');
      $(".tab-content .tab-pane#"+data).addClass('active');

      if(window.innerWidth <= 767){
        $("html, body").animate({ scrollTop: $('div[data-section-id="header"]').height() });
      }
  });  
  $('body').on('click','li.patch-letter',function(){
    $('.dropped.active .letter-drop-actions .edit').attr('data-variant_id', $(this).attr('data-var-id'));
    $('.dropped.active .letter-drop-actions .edit').attr('data-variant_src', $(this).attr('data-src'));
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    
    var variantId = $(this).attr('data-var-id');
    $('.cust-product-img .dropped.active .letter_img_wrapper_rel > img').attr('data-varid',variantId);
    
    var variantSRC = $(this).attr('data-src');
    $('.cust-product-img .dropped.active .letter_img_wrapper_rel  img').attr('src', variantSRC);
    $('.cust-product-img .dropped.active .letter_img_wrapper_rel').css('background-image', 'url('+ variantSRC +')');
    
    var variantDataPrice = $(this).attr('data-price');
    $('.cust-product-img .dropped.active .letter_img_wrapper_rel > img').attr('price', variantDataPrice);
    
    var variantTitle = $(this).attr('data-title');
    $('.cust-product-img .dropped.active .letter_img_wrapper_rel > img').attr('data-title', variantTitle);
    
    $(this).closest('#letter-drop-popup').find('.letter-img-wrapper img').attr('src', variantSRC);
    $(this).closest('#letter-drop-popup').find('.title').text(variantTitle);
    $('.pc-patch-price > dt').find('.prodName').removeClass('active');
    
});
  $('body').on('mousedown','.ui-selected-letter',function(){
      $('.image-rotate').hide();
});
  $('body').on('click','.letter-closePopup',function(){
		$(this).closest('#letter-drop-popup').removeClass('popup-open');
		$('.dropped').removeClass("active");
		$('.dropped').addClass("ui-selected-letter");
	});
  	$('body').on('click','.cust-product-img .letter-drop-actions .remove',function(){
		var patchinfo_del = $(this).attr('data-patchinfo');
		var dataVarID = $(this).closest('.ui-selected-letter').find('img').attr('price');
		$(this).parent().parent().remove();
		$('.patchInfo #'+patchinfo_del).remove();
		var priceData = $('.cust-left-wrapper a').attr('data-new-price');
		var PatchData = parseFloat(priceData) - parseFloat(dataVarID);
		var count_patch = 0;
		$('.pc-patch-price').each(function() {
			count_patch++;
		});
      // console.log('count_patch',$('.product-image-main .letter_img_wrapper_rel').length);
	});
    $('body').delegate('.cust-product-img .letter-drop-actions .edit', 'click', function(){
      $('.'+$(this).attr('data-view')).addClass('popup-open');
      $('.cust-product-img .draggable').removeClass('active');
      $(this).closest('.draggable').addClass('active');
      setTimeout(function(){
       $('.'+$(this).attr('data-view') +' li[data-var-id="'+$(this).attr('data-varid')+'"]').trigger('click');
        $('.'+$(this).attr('data-view') +'  .letter-img-wrapper .pop-up-letter').attr('src', $(this).attr('data-variant_src'));
      },200);
    });
 $('.draggable').draggable({
			helper: function() {              
				return jQuery(this).clone().appendTo('.ui-droppable-layout').css({
					'zIndex': 10
				});
			},
			cursor: 'move',
			containment: "document"
  });	

  	jQuery('.ui-droppable-layout.cust-front-img').droppable({
			activeClass: 'ui-state-hover',
			accept: '.draggable',
			drop: function(event, ui) 
			{
              var topr = 80;
              if(window.innerWidth <= 767){
                 topr = 58;
              }
              	$('.image-rotate').css({
						left:(ui.position.left),
						top:(ui.position.top + topr),
						position:'absolute'
					});
				if (!ui.draggable.hasClass("dropped"))
				{
					var clone=jQuery(ui.draggable).clone().addClass("dropped active").draggable();
                  clone.attr('data-pos-x',event.clientX);
					clone.attr('data-pos-y',event.clientY);
					clone.draggable({
						containment: '.ui-droppable-layout.cust-front-img'
					});
					
					clone.css({
						left:(ui.position.left),
						top:(ui.position.top ),
						position:'absolute'
					});
                  var clone1 = $('.image-rotate');
                  clone1.remove()
                   $(this).append('<input type="range" style="display:none;" class="image-rotate" min="-360" max="360" value="7" />');
                
                  $('.image-rotate').css({
						left:(ui.position.left),
						top:(ui.position.top + topr),
						position:'absolute'
					});

                  
					jQuery(this).append(clone);
                  if (!ui.draggable.hasClass("active"))
                  {
                    var variantID = $(this).find('.dropped.active .letter_img_wrapper_rel img').attr('data-var-id');
                    var patchInfo = variantID+'_'+drop_item_number;
                    var variantSRC = $(this).find('.dropped.active .letter_img_wrapper_rel img').attr('src');
                    $(this).find('.dropped.active').attr('type','back');
                   
                    $(this).find('.dropped.active').append('<div class="letter-drop-actions"><span class="edit"></span><span class="rotate"></span><span class="remove"></span></div>');
                    $(this).find('.dropped.active .letter-drop-actions .edit').attr('data-variant_id', variantID);
                    $(this).find('.dropped.active .letter-drop-actions .edit').attr('data-view', $(this).find('.dropped.active').attr('data-view'));
                    $(this).find('.dropped.active .letter-drop-actions .remove').attr('data-patchInfo', patchInfo);
                    if ($(this).find('.dropped.active img').attr('product-id')){
                  		$('.dropped').addClass("ui-selected-letter");
                        $('.'+$(this).find('.dropped.active').attr('data-view')).addClass('popup-open');
                        $('.'+$(this).find('.dropped.active').attr('data-view') +' li[data-var-id="'+$(this).find('.dropped.active img').attr('data-var-id')+'"]').trigger('click');
                    }else{
                      $('.dropped').removeClass("active");
                      $('.dropped').addClass("ui-selected-letter");
                    }
                    
                  }
				}
              // console.log('$(this)', $(this));
              // $('.tab-pane').hide().removeClass('active');
              // $('.nav-tabs li').removeClass('active')
            drop_item_number++;
               
			}

		});




  
function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function() {
    var canvas = document.createElement('CANVAS');
    var ctx = canvas.getContext('2d');
    var dataURL;
    canvas.height = this.height;
    canvas.width = this.width;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL(outputFormat);
    callback(dataURL);
    canvas = null;
  };
  img.src = url;
}

  // Merge
    jQuery(".custom-product-template").on('submit', function(eForm) {
              $('.letter-drop-actions').hide()
      $('.custom-product-template button[name="add"]').addClass('btn--loading')
      if($('.product-image-main .letter_img_wrapper_rel').length != 0){
      
        const unsignedUploadPreset = 'doc_codepen_example';
      eForm.preventDefault();
      function render(foo){
        var file = foo;
        var url = `https://api.cloudinary.com/v1_1/demo/upload`;
        var xhr = new XMLHttpRequest();
        var fd = new FormData();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onreadystatechange = function(e) {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var response = JSON.parse(xhr.responseText);
            var url = response.secure_url;
            console.log(url);
            var tokens = url.split('/');
            tokens.splice(-2, 0, 'w_450');
            $("#custom_preview").val(tokens.join('/'));
            const xhr1 = new XMLHttpRequest();
            console.log('1111111', multi);
            var data = {items: []} , count = 0;
            $(multi).each(function(index,val){
              count++
              console.log('val', val)
                  data.items.push({ 
                  id:parseInt(val.id) , 
                  quantity: val.qty,
                  properties: {
                    preview:tokens.join('/'),
                    "subitem":true
                  }
              });
              
              if(count == multi.length){
                  xhr1.open('POST', '/cart/add.js', true);
                  xhr1.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                  xhr1.send(JSON.stringify(data));
                  xhr1.onreadystatechange = function(e) {
                    if (xhr1.readyState == 4 && xhr.status == 200) {
                      eForm.currentTarget.submit();
                    }
                  }
              }
            })
          }
        };
        fd.append('upload_preset', unsignedUploadPreset);
        fd.append('tags', 'browser_upload');
        fd.append('file', file);
        xhr.send(fd);
      }
  
  html2canvas($('.cust-product-img'), {  
    useCORS: true,
    onrendered: function (canvas) {
      console.log('canvas', canvas);
      var canvasImg = canvas.toDataURL("image/jpg");
        render(canvasImg);
    }
  });
    function findOcc(arr, key){
        let arr2 = [];
        arr.forEach((x)=>{
           if(arr2.some((val)=>{ return val[key] == x[key] })){
             arr2.forEach((k)=>{
               if(k[key] === x[key]){ 
                 k["qty"]++
               }
            })
           }else{
             let a = {}
             a[key] = x[key]
             a["qty"] = 1
             arr2.push(a);
           }
        })
          
        return arr2
    }
    var multi = [];
    $('.product-image-main .letter_img_wrapper_rel').each(function(index,data){
     multi.push({id:$(this).find('img').attr('data-varid')});
    })
    multi =  findOcc(multi, 'id')
  }else{
    eForm.currentTarget.submit();
  }
 });

  
})


$(document).ready(function(){
  $(".product__thumb-item img").click(function () {
    var $src = $(this).attr("src");
    console.log(src);
    // $(".custom-product-show").fadeIn();
    $(".custom-product-show").css('display','flex');
    $(".custom-product-show .img-show img").attr("src", $src);
  });
  
  $("span.custom-product-close, .custom-product-overlay").click(function () {
      $(".custom-product-show").fadeOut();
    $(".custom-product-show").css('display','none');
  });

  $('.product__thumbs--scroller').slick({
  dots: false,
    arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
});